import { AnchorGroup } from "@/components/anchors-navigation";
import FilterButton from "@/components/filtering/Button";
import SoftwareButton from "@/components/filtering/SoftwareButton";
import { Element, useNode } from "@craftjs/core";
import StepButtonContainer from "./components/ButtonContainer";
import ContentContainer from "./components/ContentContainer";
import StepHeading from "./components/Heading";
import StepParagraph from "./components/Paragraph";
import StepTextContainer from "./components/TextContainer";

const Step2Content = () => {
    const {
        connectors: { connect },
    } = useNode();

    return (
        <div ref={(ref) => connect(ref!)}>
            <main className="container relative mx-auto 2xl:px-[108px] z-[1] pb-[160px]">
                <div className="relative grid grid-cols-[auto_64px_1fr] gap-13 gap-y-50 mt-36">
                    <AnchorGroup>
                        <FilterButton />
                        <SoftwareButton />
                    </AnchorGroup>

                    <div className="relative w-full col-start-2">
                        <span id="lead-0" className="absolute -top-36 w-16 h-1" />
                        <span
                            id="lead-1"
                            className="absolute -right-[0.5px] rounded-full bg-primary-200 text-primary-500 w-16 h-16 text-[35px] inline-flex items-center justify-center font-bold z-1 select-none"
                        >
                            A
                        </span>
                    </div>
                    <div>
                        <Element
                            id="heading-a"
                            is={StepHeading}
                            text={`<span class="text-primary-500">Disposer</span> d'un <span class="text-primary-500">EIR (exchange information requirements)</span>`}
                        />

                        <Element id="container-a" is={ContentContainer} canvas>
                            <Element id="content-a" is={StepTextContainer} canvas>
                                <Element
                                    id="paragraph-a-text-1"
                                    is={StepParagraph}
                                    text={`Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec quam lacus, tristique at <a href="#">nulla et, imperdiet molestie nibh</a>. Vestibulum mollis viverra odio vitae sodales.`}
                                />
                                <Element
                                    id="paragraph-a-text-2"
                                    is={StepParagraph}
                                    text={`Voir étape 1. Spécifier comment créer un EIR.`}
                                />
                            </Element>
                        </Element>
                    </div>

                    <div className="relative w-full  col-start-2">
                        <span
                            id="lead-3"
                            className="absolute -right-[0.5px] rounded-full bg-primary-200 text-primary-500 w-16 h-16 text-[35px] inline-flex items-center justify-center font-bold z-1 select-none"
                        >
                            B
                        </span>
                    </div>
                    <div>
                        <Element
                            id="heading-b"
                            is={StepHeading}
                            text={`<span class="text-primary-500">Télécharger</span> les fichiers de configuration`}
                        />

                        <Element id="container-b" is={ContentContainer} canvas>
                            <Element id="content-b" is={StepTextContainer} canvas>
                                <Element
                                    id="paragraph-b-1"
                                    is={StepParagraph}
                                    text={`Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec quam lacus, tristique at <a class="font-bold text-primary-500 hover:text-primary-600 hover:underline">nulla et, imperdiet molestie nibh</a>. Vestibulum mollis viverra odio vitae sodales.`}
                                />
                            </Element>

                            <Element id="buttons-b" is={StepButtonContainer} canvas columns={2}></Element>
                        </Element>
                    </div>

                    <div className="relative w-full  col-start-2">
                        <span
                            id="lead-2"
                            className="absolute -right-[0.5px] rounded-full bg-primary-200 text-primary-500 w-16 h-16 text-[35px] inline-flex items-center justify-center font-bold z-1 select-none"
                        >
                            C
                        </span>
                    </div>
                    <div>
                        <Element
                            id="heading-c"
                            is={StepHeading}
                            text={`Configurer <span class="text-primary-500">mon logiciel natif</span>`}
                        />
                        <Element id="container-c" is={ContentContainer} canvas>
                            <Element id="content-c" is={StepTextContainer} canvas>
                                <Element
                                    id="paragraph-c-1"
                                    is={StepParagraph}
                                    text={`Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec quam lacus, tristique at <a class="font-bold text-primary-500 hover:text-primary-600 hover:underline">nulla et, imperdiet molestie nibh</a>. Vestibulum mollis viverra odio vitae sodales.`}
                                />
                            </Element>

                            <Element id="buttons-c" is={StepButtonContainer} canvas columns={2}></Element>
                        </Element>
                    </div>

                    <div className="relative w-full  col-start-2">
                        <span
                            id="lead-4"
                            className="absolute -right-[0.5px] rounded-full bg-primary-200 text-primary-500 w-16 h-16 text-[35px] inline-flex items-center justify-center font-bold z-1 select-none"
                        >
                            D
                        </span>
                    </div>
                    <div>
                        <Element
                            id="heading-d"
                            is={StepHeading}
                            text={`<span class="text-primary-500">Encoder</span> dans mon logiciel natif`}
                        />

                        <Element id="container-d" is={ContentContainer} canvas>
                            <Element id="content-d" is={StepTextContainer} canvas>
                                <Element
                                    id="paragraph-d-1"
                                    is={StepParagraph}
                                    text={`Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec quam lacus, tristique at <a class="font-bold text-primary-500 hover:text-primary-600 hover:underline">nulla et, imperdiet molestie nibh</a>. Vestibulum mollis viverra odio vitae sodales.`}
                                />
                            </Element>

                            <Element id="buttons-d" is={StepButtonContainer} canvas columns={2}></Element>
                        </Element>
                    </div>

                    <div className="relative w-full  col-start-2">
                        <span
                            id="lead-5"
                            className="absolute -right-[0.5px] rounded-full bg-primary-200 text-primary-500 w-16 h-16 text-[35px] inline-flex items-center justify-center font-bold z-1 select-none"
                        >
                            E
                        </span>
                    </div>
                    <div>
                        <Element
                            id="heading-e"
                            is={StepHeading}
                            text={`<span class="text-primary-500">Configurer</span> l'export <span class="text-primary-500">IFC</span>`}
                        />

                        <Element id="container-e" is={ContentContainer} canvas>
                            <Element id="content-e" is={StepTextContainer} canvas>
                                <Element
                                    id="paragraph-e-1"
                                    is={StepParagraph}
                                    text={`Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec quam lacus, tristique at <a class="font-bold text-primary-500 hover:text-primary-600 hover:underline">nulla et, imperdiet molestie nibh</a>. Vestibulum mollis viverra odio vitae sodales.`}
                                />
                            </Element>

                            <Element id="buttons-e" is={StepButtonContainer} canvas columns={2}></Element>
                        </Element>
                    </div>

                </div>

                <div id="lead-6" className="col-span-2 w-[1px] mx-auto items-center" />
            </main>
        </div>
    );
};

Step2Content.craft = {
    displayName: "Content",
    rules: {
        canDrag: () => false,
        canMoveOut: () => false,
    },
    custom: {
        canDelete: false,
    },
};

export default Step2Content;
